import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { Status } from '../models/status.model';

@Injectable({ providedIn: 'root' })
export class StatusesService {
  http = inject(HttpClient);

  getList(): Observable<Status[]> {
    return this.http.get<Status[]>('Status');
  }

  organizeTypesByGroup(statuses: Status[]): { [key: string]: Status[] } {
    const groupedStatus: { [key: string]: Status[] } = {};
    statuses.forEach((status) => {
      if (!groupedStatus[status.group]) {
        groupedStatus[status.group] = [];
      }
      groupedStatus[status.group].push(status);
    });
    return groupedStatus;
  }

}
